import { h } from "preact";

import IconProps from "./IconProps";

function IconZoomOut({ width, height, color }: Omit<IconProps, "class">) {
    return (
        <svg width={width} height={height} viewBox="0 0 12 12">
            <rect fill={color} y="5" width="12" height="2" rx="1"/>
        </svg>
    );
}

IconZoomOut.defaultProps = {
    color: "var(--teflon)",
    width: 12,
    height: 12
};

export default IconZoomOut;
